<script lang="ts">
  export let width: number = 130;
  export let height: number = 80;
  export let className: string = "";
  // Font Awesome solid icons preferred
  export let bridgeClass: string = "fa-solid fa-bridge";
  export let palmClass: string = "fa-solid fa-tree-palm";

  export let distanceText: string;

</script>

<div class="relative" style={`width:${width}px;height:${height}px;`}>
  <svg
    {width}
    {height}
    viewBox="0 0 130 80"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Tour De California passport stamp"
    class={className}
  >
    <title>Tour De California Passport Stamp</title>

    <defs>
      <!-- Arch path for curved title -->
      <path id="topArch" d="M 18 36 A 47 22 0 0 1 112 36" />
    </defs>

    <!-- Golden Gate arch crest frame -->
    <!-- Outer frame: squared bottom, rounded arch top -->
    <path
      d="M 12 70 L 12 28 A 53 23 0 0 1 118 28 L 118 70 Z"
      fill="none"
      stroke="#000"
      stroke-width="1.8"
    />

    <!-- Inner frame rule -->
    <path
      d="M 18 66 L 18 34 A 49 27 0 0 1 112 34 L 112 66 Z"
      fill="none"
      stroke="#000"
      stroke-width="0.9"
      opacity="0.95"
    />

    <!-- Column ticks (rivet-like) along the verticals -->
    <g stroke="#000" stroke-width="1.2" stroke-linecap="round" opacity="0.85">
      <!-- Left column ticks -->
      <path d="M 14 40 L 16 40" />
      <path d="M 14 46 L 16 46" />
      <path d="M 14 52 L 16 52" />
      <path d="M 14 58 L 16 58" />
      <!-- Right column ticks -->
      <path d="M 114 40 L 116 40" />
      <path d="M 114 46 L 116 46" />
      <path d="M 114 52 L 116 52" />
      <path d="M 114 58 L 116 58" />
    </g>

    <!-- Bay silhouette (subtle fill, still black-only) -->
    <path
      d="M 20 50 C 32 44, 45 54, 60 49 C 75 44, 92 54, 110 48 L 110 56 L 20 56 Z"
      fill="#000"
      opacity="0.08"
    />

    <!-- Coastal route (wavy stroke) -->
    <path
      d="M 24 48 C 38 43, 50 52, 62 48 C 74 44, 88 52, 106 46"
      fill="none"
      stroke="#000"
      stroke-width="1.2"
      stroke-dasharray="3 2"
      opacity="0.85"
    />

    <!-- Title text on top arch -->
    <text
      fill="#000"
      font-size="9"
      font-weight="900"
      letter-spacing="0.7"
      text-anchor="middle"
      style="paint-order: stroke fill; stroke: #000; stroke-width: 0.6;"
    >
      <textPath href="#topArch" startOffset="50%">TOUR DE CALIFORNIA</textPath>
    </text>

    <!-- Bottom ribbon for distance -->
    <g transform="translate(65,64)">
      <!-- <rect x="-32" y="-8" width="64" height="14" rx="3" ry="3" fill="#000" opacity="0.08" /> -->
      <text x="0" y="-2" fill="#000" font-size="8" font-weight="700" text-anchor="middle" style="letter-spacing:1px;">{distanceText}</text>
    </g>
  </svg>

  <!-- Font Awesome overlays -->
  <!-- Bridge at the top center under the arch -->
  <div class="absolute" style="top:17px;left:50%;transform:translateX(-50%);color:#000;">
    <i class={bridgeClass} style="font-size:18px;line-height:1;color:#000;opacity:0.95;"></i>
  </div>

  <!-- Palm tree along the coastline (left-mid) -->
  <div class="absolute" style="top:44px;left:36px;transform:translate(-50%, -50%);color:#000;">
    <i class={palmClass} style="font-size:16px;line-height:1;color:#000;opacity:0.95;"></i>
  </div>
  <!-- Palm tree along the coastline (right-mid) -->
  <div class="absolute" style="top:44px;left:94px;transform:translate(-50%, -50%);color:#000;">
    <i class={palmClass} style="font-size:16px;line-height:1;color:#000;opacity:0.95;"></i>
  </div>
</div>
